import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const simpleFiltersApi = createApi({
  reducerPath: "simpleFiltersApi",
  baseQuery,
  tagTypes: ['SimpleFilters'],
  endpoints: (builder) => ({
    getSimpleFilters: builder.query({
      query: () => "simple-filters",
      providesTags: ['SimpleFilters'],
    }),
  }),
});

export const { useGetSimpleFiltersQuery } = simpleFiltersApi;